import { io } from "socket.io-client";

let socket = null;

// 🔹 Mémoire des rooms
let currentClientRoom = null;
let currentMerchantRoom = null;

function getOrCreateSocket() {
  if (socket) return socket;

  socket = io("https://souqi-api.onrender.com", {
    transports: ["websocket"],
    autoConnect: true,
    reconnection: true,
  });

  socket.on("connect", () => {
    

    // 🔁 Rejoin CLIENT si existant
    if (currentClientRoom) {
      socket.emit("join_client", currentClientRoom);
    }

    // 🔁 Rejoin MARCHAND (CE QUI MANQUAIT)
    if (currentMerchantRoom) {
      socket.emit("join_merchant", currentMerchantRoom);
    }
  });

  socket.on("disconnect", () => {
  });

  return socket;
}

// ================= CLIENT =================
export function initClientSocket(phone) {
  const s = getOrCreateSocket();
  const normalizedPhone = String(phone || "").trim();
  if (!normalizedPhone) return s;

  if (currentClientRoom === normalizedPhone && s.connected) {
    return s;
  }

  currentClientRoom = normalizedPhone;
  s.emit("join_client", normalizedPhone);

  return s;
}

// ================= MARCHAND =================
export function initMerchantSocket(merchantId) {
  const s = getOrCreateSocket();
  const id = String(merchantId || "").trim();
  if (!id) return s;

  if (currentMerchantRoom === id && s.connected) {
    return s;
  }

  currentMerchantRoom = id;
  s.emit("join_merchant", id);

  return s;
}

// ================= UTIL =================
export function getSocket() {
  return getOrCreateSocket();
}

